import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarTenagaKesehatanDetailAdmin from "../../components/TopBarTenagaKesehatanDetailAdmin";
import ProfileTenagaKesehatanAdmin from "../../components/ProfileTenagaKesehatanAdmin";
import "../../CSS/ProfileTenagaKesehatan.css";

function HalamanProfileTenagaKesehatan() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarTenagaKesehatanDetailAdmin />

        {/* Konten utama */}
        <div className="main-contentprofile">
          <ProfileTenagaKesehatanAdmin />
        </div>

        
      </div>
    </div>
  );
}

export default HalamanProfileTenagaKesehatan;
